import React from "react";
import { styled } from "@mui/system";
import FocusCorners from "./FocusCorners"; // 假设你已经创建了 FocusCorners 组件
import { ReactComponent as BackIcon } from "../../assets/icons/trade/back.svg";
import { useHistory } from "react-router-dom";
import { Box } from "@mui/material";
import LineBgImage from "../../assets/icons/dashboard/lines-bg.png";

const StyledButton = styled("div")(({ theme }) => ({
  backgroundImage: `url(${LineBgImage})`,
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  height: "40px",
  width: "120px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "16px",
  lineHeight: "22px",
  textAlign: "center",
  letterSpacing: "0.08em",
  // transition: "all 0.3s",
  cursor: "pointer",
  borderRadius: "4px",
  userSelect: "none",
  color: "#fff",

  "& .focus-corners": {
    // "--corner-margin": "6px"
    // transition: "all 0.3s"
  },

  "& .focus-corners-inner": {
    transform: "translateX(0)",
    transition: "all 0.3s"
  },
  "&:hover": {
    backgroundColor: "rgba(255, 135, 54, 0.30)",
    color: "var(--brand)",

    "& .focus-corners": {
      // "--corner-margin": "6px"
      "--corner-color": "var(--brand)",
      "--corner-margin": "0"
    },
    "& .focus-corners-inner": {
      transform: "translateX(-8px)"
    }
  },
  "&:active": {
    transform: "scale(0.97)"
  },
  "&.active": {
    background: ` rgba(255, 135, 54, 0.4)`,
    "background-blend-mode": "soft-light, normal, normal",
    color: "#fff",

    "& .focus-corners": {
      "--corner-color": "var(--brand)",
      "--corner-margin": "0"
    }
  }
}));

const FocusGhostButton = ({ children, ...props }) => {
  const { replace } = useHistory();
  const handleClick = () => {
    replace("/");
  };

  return (
    <StyledButton {...props} onClick={() => handleClick()}>
      <FocusCorners>
        <Box
          sx={{ display: "flex", alignItems: "center", gap: "4px" }}
          className="focus-corners-inner">
          <BackIcon />
          {children}
        </Box>
      </FocusCorners>
    </StyledButton>
  );
};

export default FocusGhostButton;
